var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({},_vm.$listeners),[_c('the-icon',{ref:"theicon",style:({width: (_vm.size + "px"),height: (_vm.size + "px")})})],1)}
var staticRenderFns = []

export { render, staticRenderFns }